import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { LucideDynamicIcon, LucideIconInput } from '@lucide/angular';

export type IconSizes = 'xs' | 's' | 'sm' | 'm' | 'l' | 'xl' | 'xxl';

@Component({
  selector: 'ptl-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [LucideDynamicIcon],
})
export class IconComponent {
  icon = input.required<LucideIconInput>();
  size = input<IconSizes>('m');
  color = input<string>('currentColor');

  protected readonly sizeMap: Record<IconSizes, number> = {
    xs: 16,
    s: 16,
    sm: 15,
    m: 20,
    l: 24,
    xl: 24,
    xxl: 80,
  };

  protected readonly resolvedSize = computed(() => this.sizeMap[this.size()]);
}
